import gql from 'graphql-tag';

export default gql`
  directive @expensive on FIELD_DEFINITION
`;
